import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Footer from '../components/Footer';
import HeroBanner from '../components/HeroBanner';
import { FiPhone, FiSend } from 'react-icons/fi';
import { MdShoppingCart } from 'react-icons/md';
import { FaBars, FaWhatsapp } from 'react-icons/fa';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";
import { AiOutlineUser } from 'react-icons/ai';
import { apiClient } from '../config/apiConfig';

const Contact: React.FC = () => {

  const [formData, setFormData] = useState({
    cusName: '',
    cusEmail: '',
    subject: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [customerName, setCustomerName] = useState<string | null>(null);

  useEffect(() => {
    const name = localStorage.getItem("customerName");
    if (name) {
      setCustomerName(name);
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.cusName || !formData.cusEmail || !formData.subject || !formData.message) {
      alert("All fields required");
      return;
    }

    try {
      setLoading(true);

      const res = await apiClient.post("/api/CusContact/submit", {
        cusName: formData.cusName,
        cusEmail: formData.cusEmail,
        subject: formData.subject,
        message: formData.message
      }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      alert("Message sent successfully ✅");

      // clear form
      setFormData({
        cusName: '',
        cusEmail: '',
        subject: '',
        message: ''
      });

    } catch (err: any) {
      console.error('Error details:', err);
      if (err.code === 'ERR_NETWORK') {
        alert("Cannot connect to server. Please make sure the backend is running on https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net ❌");
      } else if (err.response?.status === 400) {
        const errorMsg = err.response?.data?.message || "Please check your inputs";
        const errors = err.response?.data?.errors;
        if (errors && Array.isArray(errors)) {
          alert("Validation Error:\n" + errors.join("\n") + " ❌");
        } else {
          alert("Invalid input: " + errorMsg + " ❌");
        }
      } else if (err.response?.status === 500) {
        alert("Server error: " + (err.response?.data?.message || "Please try again later") + " ❌");
      } else {
        alert("Failed to send message ❌");
      }
    } finally {
      setLoading(false);
    }
  };



  // Fetch cart items
  const fetchCart = async () => {
    try {
      const customerId = localStorage.getItem("customerId");
      if (!customerId) {
        console.error("No customerId found in localStorage");
        return;
      }

      const response = await axios.get(
        `https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/Cart/GetCartByCustomerId?customerId=${customerId}`
      );

      console.log("Cart data:", response.data);
      setCartItems(response.data.items || []);
    } catch (error) {
      console.error("Error fetching cart items:", error);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  const totalCount = cartItems.length;

  return (
    <div className="goto-here">
      {/* Top Bar */}
      <div className="py-1 bg-primary w-100">
        <div className="container">
          <div className="row d-flex align-items-center text-white">
            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiPhone size={14} className="mr-2" />
              <span>+91 9148761750</span>
            </div>

            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiSend size={14} className="mr-2" />
              <span>care@fhome.shop</span>
            </div>

            <div className="col-12 col-md text-md-right">
              <span>3-5 Business days delivery & Free Returns</span>
            </div>
          </div>
        </div>
      </div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%", width: "80px" }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">Shop</a>
                </div>
              </li>
              <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
              {/* <li className="nav-item"><a href="/blog" className="nav-link">Blog</a></li> */}
              <li className="nav-item active"><a href="/contact" className="nav-link">Contact</a></li>
              <li className="nav-item cta cta-colored"><a href="/cart" className="nav-link"><span><MdShoppingCart size={18} /></span> [{totalCount}]</a></li>
              <li className="nav-item">
                <a
                  href="/my-account"
                  className="nav-link d-flex align-items-center"
                  style={{ gap: "6px" }}
                >
                  <AiOutlineUser size={24} style={{ color: "#898989" }} />

                  {customerName ? (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999",
                        maxWidth: "120px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                      title={`Hi, ${customerName}`}
                    >
                      Hi, {customerName}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999"
                      }}
                    >
                      Login
                    </span>
                  )}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <HeroBanner image="images/fhome-honey-pour.jpg">
        <div className="row no-gutters slider-text align-items-center justify-content-center">
          <div className="col-md-9 ftco-animate text-center">
            <p className="breadcrumbs"><span className="mr-2"><a href="/">Home</a></span> <span>Contact us</span></p>
            <h1 className="mb-0 bread">Contact us</h1>
          </div>
        </div>
      </HeroBanner>
      {/* Contact Info Section */}
      <section className="ftco-section contact-section bg-light">
        <div className="container">
          <div className="row block-9">
            <div className="col-md-6 order-md-last d-flex">

              {/* ✅ CONNECTED FORM */}
              <form className="bg-white p-5 contact-form" onSubmit={handleSubmit}>

                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Your Name"
                    name="cusName"
                    value={formData.cusName}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Your Email"
                    name="cusEmail"
                    value={formData.cusEmail}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <textarea
                    cols={30}
                    rows={7}
                    className="form-control"
                    placeholder="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>

                <div className="form-group">
                  <button
                    type="submit"
                    className="btn btn-primary py-3 px-5"
                    disabled={loading}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </button>
                </div>

              </form>
            </div>
            <div className="col-md-6 d-flex align-items-stretch">
              <div
                className="block-23 bg-white p-5 rounded shadow w-100"
                style={{ minHeight: "400px" }}
              >
                <h5 className="mb-4" style={{ color: "#28a745", fontWeight: "bold" }}>Get In Touch:</h5>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  <li className="mb-4 d-flex align-items-start">
                    <FaMapMarkerAlt
                      style={{ marginRight: "12px", color: "#28a745", fontSize: "20px", marginTop: "4px" }}
                    />
                    <span className="text">
                      <strong>Address:</strong><br />
                      PLOT NO:5, THIRUVALLUVAR STREET,<br />
                      NGGO NAGAR, THIRUKOVILUR,<br />
                      THIRUKOVILUR BLOCK, VILUPPURAM,<br />
                      TAMILNADU - 605757
                    </span>
                  </li>
                  <li className="mb-3 d-flex align-items-center">
                    <FaPhone
                      style={{ marginRight: "12px", color: "#007bff", fontSize: "18px" }}
                    />
                    <a
                      href="tel:+919148761750"
                      className="text text-decoration-none text-dark"
                    >
                      +91 9148761750
                    </a>
                  </li>
                  <li className="d-flex align-items-center">
                    <FaEnvelope
                      style={{ marginRight: "12px", color: "#dc3545", fontSize: "18px" }}
                    />
                    <a
                      href="mailto:care@fhome.shop"
                      className="text text-decoration-none text-dark"
                    >
                      care@fhome.shop
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
      <a
        href="https://wa.me/919148761750"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
      </a>
    </div>
  );
};

export default Contact;

